var React = require('react');

function IconStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","d":"M10,1.3l2.388,6.722H18.8l-5.232,3.948l1.871,6.928L10,14.744l-5.438,4.154l1.87-6.928L1.199,8.022h6.412\n\tL10,1.3z"}));
}

IconStar.defaultProps = {"version":"1.1","id":"Star","x":"0px","y":"0px","viewBox":"0 0 20 20","enableBackground":"new 0 0 20 20","xmlSpace":"preserve"};

module.exports = IconStar;

IconStar.default = IconStar;
